export class OrganizationStateModel {
  organizations: OrganizationListItem[] | undefined;
  current: Organization | undefined;
  registrationError: boolean;
  searchResult: SearchResultItem[] | undefined;
}

export class Organization {
  id: string;
  verified: boolean;
  lastMemberRegistryUpdate: Date;
  removeDate?: Date;
  daysSinceLastMemberRegistryUpdate?: number;
  suggestMemberRegistryImport: boolean;
  name: string;
  parentName: string;
  isSupervisor: boolean;
  administratorRequests: AdministratorRequest[];
  administrators: Administrator[];
  parentAdministrators: Administrator[];
  outboundEmailAddress: string;
  demoMode: boolean;
  lastMemberImportSource: MemberImportSources;
  googleSheetMemberRegistryUrl: string;
  logoUrl: string;
  logoSize: {
    width: number;
    height: number;
  };
  paymentSettings: PaymentSettings;
  smsEnabled: boolean;
  subParticipantsEnabled: boolean;
  organizationNumber: string;
  coAddress?: string;
  streetAddress: string;
  zipCode: string;
  city: string;

  childOrganizations: ChildOrganization[];
  retiredFiles: RetiredFile[];
  allowKakserviceIntegration: boolean;
  walletFeatureEnabled: boolean;
}

export class RetiredFile {
  name: string;
  url: string;
}

export class ChildOrganization {
  id: string;
  name: string;
  logoUrl: string;
  administrators: Administrator[];
  administratorRequests: Administrator[];
  activities: ChildActivity[];
}

export class ChildActivity {
  id: string;
  name: string;
  imageUrl: string;
  participantCount: number;
  productCount: number;
  productSelectionDeadline: Date;
  paymentDeadline: Date;
  responsible: string;
}

export class AdministratorRequest {
  id: string;
  name: string;
  email: string;
  lastIdentityProvider: string;
  profileImageUrl: string;
}

export class Administrator {
  id: string;
  name: string;
  email: string;
  lastIdentityProvider: string;
  profileImageUrl: string;
}

export class PaymentSettings {
  swish: SwishSettings;
  defaultPartialPaymentAllowed: boolean;
  defaultSmsPaymentReminderEnabled: boolean;
}

export class SwishSettings {
  number: string;
  recipients: SwishRecipient[];
  prefix: string;
}

export class SwishRecipient {
  number: string;
  name: string;
  default: boolean;
  enabled: boolean;
}

export class OrganizationList {
  organizations: OrganizationListItem[];
}

export class OrganizationListItem {
  id: string;
  name: string;
  verified: boolean;
  logoUrl: string;
  parent?: string;
  removeDate?: Date;
  childOrganizations: OrganizationListItem[];
}

export class SearchResponse {
  searchResult: SearchResultItem[];
}

export class SearchResultItem {
  id: string;
  name: string;
  logoUrl: string;
  alreadyAdministrator: boolean;
  requestAlreadySent: boolean;
  isSupervisor: boolean;
}

export enum MemberImportSources {
  idrottOnline = 'IdrottOnline',
  lagetse = 'Laget.se',
  svenskaLag = 'Svenskalag',
  excelFile = 'Excelfil',
  googleSheet = 'Google Sheet',
}
